import React from "react";
import DoctorsCard from "../cards/DoctorsCard";

// Style \\
import "../../assets/styles/sections/doctors.scss";

// Swipper \\
import {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
} from "swiper/modules";

import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import "swiper/css/autoplay";

const Doctors = () => {
  return (
    <section className="doctors">
      <div className="container">
        <div className="doctors_items">
          <div className="doctors_items_title">
            <h3>Trusted Care</h3>
            <p>Our Doctors</p>
          </div>

          <div className="doctors_items_cards">
            {/* <Swiper
              className="swipperHead"
              modules={[Navigation, Pagination, Scrollbar, A11y]}
              // spaceBetween={120}
              breakpoints={{
                992: {
                  spaceBetween: 40,
                  slidesPerView: 3,
                },
                768: {
                  spaceBetween: 40,
                  slidesPerView: 2,
                },
                576: {
                  spaceBetween: 40,
                  slidesPerView: 2,
                },
              }}
              // slidesPerView={3}
              autoplay
              pagination={{ clickable: true }}
              onSlideChange={() => console.log("slide change")}
            >
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide>
                <DoctorsCard />
              </SwiperSlide>
              <div className="dot">...</div>
            </Swiper> */}
            <Swiper
              className="swiper"
              modules={[Navigation, A11y]}
              breakpoints={{
                1240: {
                  spaceBetween: 90,
                  slidesPerView: 3,
                },
                992: {
                  spaceBetween: 90,
                  slidesPerView: 3,
                },
                768: {
                  spaceBetween: 10,
                  slidesPerView: 3,
                },
                576: {
                  spaceBetween: 90,
                  slidesPerView: 2,
                },
                480: {
                  spaceBetween: 90,
                  slidesPerView: 1,
                },
              }}
              navigation
              // pagination={{ clickable: true }}
              // scrollbar={{ draggable: true }}
              onPlay={{ Autoplay }}
              onSwiper={(swiper) => console.log(swiper)}
              onSlideChange={() => console.log("slide change")}
            >
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
              <SwiperSlide className="SwiperSlide">
                <DoctorsCard />
              </SwiperSlide>
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Doctors;
